const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withSetURL = require("../core/hoc/withSetURL");
const AT = require("../core/vault/ActionTypes");
const OpsSchool = require("./vault/OpsSchool");
const {atClasses, atSchool} = require("../core/vault/StateCursors");
const MultiSlots = require("../core/vault/MultiSlots");
const LoadGuard = require("../core/view/LoadGuard");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const ClassesUtil = require("./util/ClassesUtil");

const styles = require("./styles/PageSchoolTestList.css");

// This is a quick isolated page listing all tests for the currently logged in
// teacher, which is linked to by Academy materials.

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withSetURL(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			schoolState: atSchool(vaultState).get(),
			classes: atClasses(vaultState).get() || {},
			mainAccountLoad: OpsSchool.getAccountsLoad(atSchool(vaultState).get()),
		}),
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageSchoolTestList",

		propTypes: {
			user: PT.object.isRequired,
			space: PT.string,
			tab: PT.string,
			pageData: PT.object,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			setURL: PT.func.isRequired,
			dispatch: PT.func.isRequired,
			schoolState: PT.object.isRequired,
			classes: PT.object.isRequired,
			mainAccountLoad: PT.object.isRequired,
		},

		loadAccountMain: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ACCOUNTS_REQUEST,
			});
		},

		loadClasses: function(classIDs) {
			this.props.dispatch({
				type: AT.LOAD_REPORT_CLASSES_SLOT_REQUEST,
				classIDs,
			});
		},

		renderTestTable: function(data) {
			const rows = data.map((r, i) => {
				const classPageData = {
					classID: r.classID,
				};
				const testPageData = {
					classID: r.classID,
					grade: r.gradeID,
					bookTest: r.bookHash,
				};
				return (
					<div className={i % 2 === 0 ? styles.trEven : styles.trOdd} key={i}>
						<div className={styles.tdTest}>
							<Link
								to={URLMake.forSchool("reports", "classes", testPageData)}
								className={styles.link}
							>
								{r.testDisplayName}
							</Link>
						</div>
						<div className={styles.tdClass}>
							<Link
								to={URLMake.forSchool("reports", "classes", classPageData)}
								className={styles.link}
							>
								{r.classDisplayName}
							</Link>
						</div>
						<div className={styles.tdDate}>{r.dateFormatted}</div>
					</div>
				);
			});

			return (
				<div className={styles.table}>
					<div className={styles.tHeader}>
						<div className={styles.thTest}>Test</div>
						<div className={styles.thClass}>Class</div>
						<div className={styles.thDate}>Date</div>
					</div>
					<div className={styles.tBody}>{rows}</div>
				</div>
			);
		},

		renderTestList: function() {
			const classes = MultiSlots.getFormattedData(this.props.classes);
			const allUserTests = ClassesUtil.getAllUserTests(classes);

			if (!allUserTests.length) {
				return (
					<div className={styles.tableContainer}>
						<div className={styles.empty}>
							There are no tests in any of your classes.{" "}
						</div>
						<div className={styles.empty}>
							<Link
								to={URLMake.forSchool("reports", "classes")}
								className={styles.link}
							>
								Back to Reports
							</Link>
						</div>
					</div>
				);
			}

			const groups = ClassesUtil.groupUserTests(allUserTests);
			return groups.map((g, i) => {
				return (
					<div className={styles.tableContainer} key={i}>
						<div className={styles.tableTitle}>{g.title}</div>
						{this.renderTestTable(g.data)}
					</div>
				);
			});
		},

		render: function() {
			const {user, schoolState, classes, mainAccountLoad} = this.props;
			const renderClasses = () => {
				const viewableClasses = OpsSchool.getViewableClasses(
					schoolState,
					user.userID
				);
				const classIDs = _.map(viewableClasses, c => c.id);

				return (
					<LoadGuard
						identifier="reportClasses"
						status={classes}
						requestLoad={() => this.loadClasses(classIDs)}
						loadingView={"logo"}
						logoColorType={"white"}
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={this.renderTestList}
						multiSlotIDs={classIDs}
					/>
				);
			};

			const classesEl = (
				<LoadGuard
					identifier="accountsMain"
					status={mainAccountLoad}
					requestLoad={this.loadAccountMain}
					loadingView={"logo"}
					logoColorType={"color"}
					errorView="refreshOffice"
					renderLoaded={renderClasses}
				/>
			);

			return (
				<div className={styles.main}>
					<div className={styles.title}>Reports - Test List</div>
					<div className={styles.content}>{classesEl}</div>
				</div>
			);
		},
	})
);
